import { render, staticRenderFns } from "./ListJsonDataImportEditor.vue?vue&type=template&id=1dddf388&"
import script from "./ListJsonDataImportEditor.vue?vue&type=script&lang=js&"
export * from "./ListJsonDataImportEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports